import { useState } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Text } from './CommonComponents';
import { Grid } from './Grid';
import { BORDER_RADIUS, COLOURS, PAD_LARGE, PAD_MEDIUM, PAD_MEDIUM_NUMBER } from '../providers/designSystem';

export const FileUploader = ({ handleUpload, accept }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileSelect = event => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    return (
        <Grid numberOfColumns={1} gap={PAD_MEDIUM_NUMBER}>
            <Box
                paddingX="12px"
                paddingY="8px"
                display="flex"
                flexDirection="row"
                borderRadius={BORDER_RADIUS}
                alignItems="center"
                justifyContent="space-between"
                sx={{ border: `2px solid ${COLOURS.violet}` }}
            >
                <Text>{selectedFile?.name}</Text>
                <input
                    accept={accept}
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                />
                <label htmlFor="contained-button-file">
                    <IconButton color="primary" component="span">
                        <UploadFileRoundedIcon />
                    </IconButton>
                </label>
            </Box>

            <Button
                variant="contained"
                onClick={() => handleUpload(selectedFile)}
                disabled={!selectedFile}
                sx={{
                    paddingX: PAD_LARGE,
                    paddingY: PAD_MEDIUM,
                }}
            >
                Upload
            </Button>
        </Grid>
    );
};
